import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from 'react-query';
import { CasePageHeader } from 'src/components/organisms/Case/CasePageHeader/CasePageHeader';
import { FormattedNamedOffender } from 'src/components/pages/Case/helpers/namedOffender';
import {
  CaseAttributesType,
  CaseByIdQuery,
  CategoryDisplayType,
  ReportStatus,
  UserType,
} from 'src/graphql';
import { CaseTypeEnum } from 'src/types';
import { CaseScreenHeaderContainer } from './CaseScreenHeader.styles';

type CaseLeadOption = { label: string; value: number };

export interface CaseScreenHeaderProps {
  caseType: CaseTypeEnum;
  label: string;
  caseId: string;
  caseDisplayId: string;
  status: ReportStatus | undefined;
  expirationTime: Date;
  caseLead: UserType | null;
  availableCaseLeads: CaseLeadOption[];
  caseTeamMembers: UserType[];
  viewer: UserType;
  availableCategoriesList: CategoryDisplayType[];
  categories: CategoryDisplayType[];
  addCaseCategory: (vars: { categoryId: number; caseId: string }) => void;
  removeCaseCategory: (vars: { categoryId: number; caseId: string }) => void;
  refetchCaseQuery: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined,
  ) => Promise<QueryObserverResult<CaseByIdQuery, unknown>>;
  submittedAt: Date;
  caseAttributes?: CaseAttributesType | null;
  isMIReport: boolean;
  namedOffenders: FormattedNamedOffender[];
  isCaseSanitized?: boolean;
  submissionRoute?: string;
}

export const CaseScreenHeader = ({
  caseType,
  submissionRoute,
}: CaseScreenHeaderProps) => {
  return (
    <CaseScreenHeaderContainer>
      <CasePageHeader caseType={caseType} submissionRoute={submissionRoute} />
    </CaseScreenHeaderContainer>
  );
};
